import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../pages/base-error";
import { Service } from "../../../../../models/service";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";
import { BotControllerService } from "../../../../../services/role-controller/bot-controller.service";
import { Bot } from "../../../../../models/bot";
import { ActivatedRoute } from "@angular/router";
import { DatabaseItemComponent } from "../../../../pages/service-detail/database-item/database-item.component";

@Component({
  selector: "service-settings-databases",
  templateUrl: "./service-settings-databases.component.html",
  providers: [ServiceControllerService, ToastrService, BotControllerService],
})
export class ServiceSettingsDatabasesComponent extends BaseError implements OnInit {

  public serviceId: string;
  @Input() public service: Service;
  public bots: Bot[] = [];

  @ViewChild(DatabaseItemComponent) public databaseItemComponent: DatabaseItemComponent;

  constructor(
    private serviceControllerService: ServiceControllerService,
    public toastr: ToastrService,
    public botController: BotControllerService,
    private route: ActivatedRoute,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    if (!this.service?.id || !this.service) {
      this.route.parent.params.subscribe((params) => {
        this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
        if (this.serviceId !== null) {
          this.loadService();
        } else {
          this.service = new Service();
        }
      });
    } else {
      this.serviceId = this.service.id;
      this.getBotsList();
    }
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        this.service = data;
        this.getBotsList();
      },
    );
  }

  public refreshExternalServices() {
    this.serviceControllerService.refreshAllInstances().subscribe(
        () => {
          this.databaseItemComponent.initLocations();
        },
        (err) => this.showErrorMessage(err),
    );
  }

  public getBotsList() {
    this.botController.getServiceBots(this.serviceId).subscribe(
      (data) => {
        this.bots = data.filter((bot) => bot.botType !== null && bot.botType !== "document" && bot.botServiceId);
      },
    );
  }
}
